export default function Header() {
  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <a href="#" className="flex items-center gap-3">
          <img
            src="/armadapos-logo.png"
            alt="Armada POS"
            className="h-8 w-auto"
          />
          <span className="sr-only">Armada POS</span>
        </a>

        <nav className="hidden md:flex items-center gap-6 text-sm font-medium">
          <a href="#features" className="hover:text-blue-700">Features</a>
          <a href="#comparison" className="hover:text-blue-700">Why Armada</a>
          <a href="#industries" className="hover:text-blue-700">Industries</a>
          <a href="#hardware" className="hover:text-blue-700">Hardware</a>
          <a href="#integrations" className="hover:text-blue-700">Integrations</a>
          <a href="#faq" className="hover:text-blue-700">FAQ</a>
          <a
            href="#signup"
            className="inline-flex items-center gap-2 rounded-lg px-4 py-2 bg-blue-600 text-white hover:bg-blue-700"
          >
            Start Free Trial
          </a>
        </nav>

        <a
          href="#signup"
          className="md:hidden inline-flex items-center gap-2 rounded-lg px-3 py-2 bg-blue-600 text-white hover:bg-blue-700 text-sm"
        >
          Free Trial
        </a>
      </div>
    </header>
  );
}
